module.exports = __webpack_public_path__ + "img/about_image2.e760c327.png";